import React, { useState } from "react";
import axios from "../../api/axios";
import ReportFilter from "./components/ReportFilter";

const TimeToSellReport = () => {
  const [filters, setFilters] = useState({});
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchReport = async () => {
    setLoading(true);
    try {
      const res = await axios.get("/api/reports/time-to-sell", { params: filters });
      setRows(res.data.data || []);
    } catch (err) {
      console.error("Failed to load time-to-sell report", err);
      setRows([]);
    } finally {
      setLoading(false);
    }
  };

  const download = async (type) => {
    try {
      const res = await axios.get(`/api/reports/time-to-sell/${type}`, {
        params: filters,
        responseType: "blob",
      });
      const url = window.URL.createObjectURL(new Blob([res.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `time-to-sell-report.${type === "csv" ? "csv" : "pdf"}`);
      document.body.appendChild(link);
      link.click();
    } catch (err) {
      console.error(`Failed to download ${type}`, err);
    }
  };

  return (
    <div className="container py-4">
      <h4 className="fw-bold mb-3">Time to Sell (avg days from listing to sale)</h4>

      <ReportFilter filters={filters} setFilters={setFilters} onSearch={fetchReport} />

      <div className="card mb-3">
        <div className="card-body d-flex justify-content-end gap-2">
          <button className="btn btn-primary" onClick={fetchReport}>
            {loading ? "Loading..." : "Search"}
          </button>
          <button className="btn btn-outline-danger" onClick={() => download("pdf")}>
            PDF Download
          </button>
          <button className="btn btn-outline-secondary" onClick={() => download("csv")}>
            CSV Download
          </button>
        </div>
      </div>

      <div className="card shadow-sm">
        <div className="card-body table-responsive">
          <table className="table table-bordered">
            <thead>
              <tr>
                <th>Unit Type</th>
                <th>Avg Days to Sell</th>
                <th>Sold Count</th>
              </tr>
            </thead>
            <tbody>
              {rows.length === 0 ? (
                <tr>
                  <td colSpan="3" className="text-center">
                    {loading ? "Loading..." : "No data"}
                  </td>
                </tr>
              ) : (
                rows.map((row, idx) => (
                  <tr key={idx}>
                    <td>{row.type_name}</td>
                    <td>{row.avg_days_to_sell}</td>
                    <td>{row.sold_count}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default TimeToSellReport;

